const constant = {
  homeList: [
    {
      path: require('../assets/img/bg_test1.png'),
      name: '测试一',
      desc: ''
    },
    {
      path: require('../assets/img/bg_test2.png') ,
      name: '测试二',
      desc: ''
    },
    {
      path: require('../assets/img/bg_test3.jpg'),
      name: '测试三',
      desc: ''
    },
  ],
  homeNews: [
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题',
      createTime: '2022-01-03'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题新题新闻标题新闻标题',
      createTime: '2022-01-04'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新新闻标题新闻标题新闻标题',
      createTime: '2022-01-01'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新闻标题新闻标题',
      createTime: '2022-01-05'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新闻标闻标题新闻标题新闻标题',
      createTime: '2022-01-05'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新新闻标题新闻标题',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新新闻标题新闻标题新闻标题',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题题新闻标题新闻标题新闻标题',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '新闻标题新闻标题新闻标题新闻标题新闻标题',
      createTime: '2022-01-02'
    }
  ],
  homeStatute: [
    {
      id: 1,
      title: '社会法规001',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '社会法规001222',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '社会法规0012222',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '社会法规00122222',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '社会法规00122222',
      createTime: '2022-01-02'
    },
    {
      id: 1,
      title: '社会法规00122222',
      createTime: '2022-01-02'
    }
  ]
}


export default constant;



// WEBPACK FOOTER //
// ./src/constant/constant.js